import {
  GET_PRODUCT_DETAILS,
  GET_PRODUCT_DETAILS_ERROR,
  GET_PRODUCT_DETAILS_SUCCESS,
} from "../constants";

export function getProductDetails(session, resolve, reject) {
  return {
    type: GET_PRODUCT_DETAILS,
    payload: session,
    resolve,
    reject,
  };
}

export const getProductDetailsSuccess = (data) => {
  return {
    type: GET_PRODUCT_DETAILS_SUCCESS,
    payload: data,
  };
};

export const getProductDetailsError = (error) => {
  return {
    type: GET_PRODUCT_DETAILS_ERROR,
    payload: error,
  };
};
